import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Carousel } from 'react-bootstrap';
//import { SuperpoweredChatThread } from "superpowered-ai";

import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactUsModal from "../components/ContactUsModal";

import ZachHeadshot from "../assets/zach_headshot.png";
import DillonHeadshot from "../assets/dillon_headshot.png";
import NickHeadshot from "../assets/nick_headshot.png";
import JustinHeadshot from "../assets/justin_headshot.png";

import LightbulbIcon from "../assets/lightbulb_icon.png";
import ProofOfConcept from "../assets/proof_of_concept_icon.png";
import PilotDev from "../assets/pilot_dev_icon.png";
import FullDev from "../assets/full_dev_icon.png";

import PilotingImage from "../assets/blogImages/piloting_image.png";
import AutomationImage from "../assets/blogImages/full_automation_image.png";
import InHouseImage from "../assets/blogImages/in_house_image.png";
import TrainingImage from "../assets/blogImages/training_vs_tuning_image.png";

import "./Home.css";

const { REACT_APP_API_KEY, REACT_APP_API_SECRET } = process.env;

const Home = () => {

    const navigate = useNavigate();

    const [showContactModal, setShowContactModal] = useState(false);

    function handleResponse(payload, response, status) {
        console.log("Payload: ", payload);
        console.log("Response: ", response);
        console.log("Status: ", status);
    }

    return (
        <section className="home-page-section">

            <Header />

            {showContactModal &&
                <ContactUsModal closeModal={() => setShowContactModal(false)} />
            }

            <div className="main-container">
                <div className="main-header-row">
                    <p id="main-header-text">
                        <b id="main-header-text-bold">AI solutions</b>{" for startups and mid-market businesses"}
                    </p>
                </div>
                <div className="main-header-row">
                    <p id="main-header-sub-text">
                        We specialize in building highly controllable and accurate generative AI systems that drive business outcomes.
                    </p>
                </div>
                <div className="main-header-button">
                    <ContactUsButton onClick={() => setShowContactModal(true)} />
                </div>
            </div>


            



            <div className="homepage-container">
                <div className="homepage-row">
                    <p className="home-page-header-text">
                        Things we've built
                    </p>
                </div>

                <CarouselItem />
            </div>


            <div className="homepage-container" style={{ display: "none" }}>
                <div className="homepage-row">
                    <p className="home-page-header-text">
                        Things we've built
                    </p>
                </div>
                <div className="things-we-built-container">
                    <div className="built-features-container">
                        <div className="built-features-col">
                            <div className="built-feature-wrapper">
                                <div className="built-feature-container">
                                    <p className="built-title-text">
                                        API for retrieval augmented generation
                                    </p>
                                    <p className="built-sub-text">
                                        This platform makes it easy for developers to build AI applications that require connecting the AI to external sources of knowledge. This platform achieves state of the art performance on a wide variety of tasks.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="built-features-col">
                            <div className="built-feature-wrapper">
                                <div className="built-feature-container">
                                    <p className="built-title-text">
                                        GenMind - AI that cites its sources
                                    </p>
                                    <p className="built-sub-text">
                                        GenMind is a horizontal AI platform for connecting AI to external sources of knowledge. All AI responses include citations so the user can verify accuracy. GenMind supports a wide variety of use cases, including long-form content generation and document reviews.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="built-features-col">
                            <div className="built-feature-wrapper">
                                <div className="built-feature-container">
                                    <p className="built-title-text">
                                        AI marketing platform for financial advisors
                                    </p>
                                    <p className="built-sub-text">
                                        We’re helping a wealth tech startup build an AI-powered marketing platform for financial advisors. It helps advisors generate compelling and compliant marketing content, like blog posts and newsletters, with a single click. The platform leverages web search to automatically pull up-to-date information about financial markets.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="homepage-container">
                <div className="homepage-row">
                    <p className="home-page-header-text">
                        Offerings
                    </p>
                </div>
                <div className="homepage-row" id="offerings-container">
                    <div className="offerings-row">
                        <div className="offerings-col offerings-left-col">
                            <div>
                                <img src={LightbulbIcon} className="offerings-icon" />
                            </div>
                            <div>
                                <p className="offerings-header-text">Strategy development</p>
                                <p className="offerings-sub-text">
                                    We'll help you figure out where the best opportunities are to deploy generative AI, given your business's unique opportunities and challenges.
                                </p>
                            </div>
                        </div>
                        <div className="offerings-col offerings-right-col">
                            <div>
                                <img src={ProofOfConcept} className="offerings-icon" />
                            </div>
                            <div>
                                <p className="offerings-header-text">Proof of concept development</p>
                                <p className="offerings-sub-text">
                                    We can do R&D work to figure out how to build even your wildest ideas.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="offerings-row">
                        <div className="offerings-col offerings-left-col">
                            <div>
                                <img src={PilotDev} className="offerings-icon" />
                            </div>
                            <div>
                                <p className="offerings-header-text">Pilot development</p>
                                <p className="offerings-sub-text">
                                    We can quickly build a pilot or MVP so you can validate your idea with a low upfront investment.
                                </p>
                            </div>
                        </div>
                        <div className="offerings-col offerings-right-col">
                            <div>
                                <img src={FullDev} className="offerings-icon" />
                            </div>
                            <div>
                                <p className="offerings-header-text">Full application development</p>
                                <p className="offerings-sub-text">
                                    When you're ready to go to production, we're here to make it happen, with a focus on reliability and cost effectiveness.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="homepage-container">
                <div className="homepage-row">
                    <p className="home-page-header-text">
                        Insights
                    </p>
                </div>

                <div className="homepage-row" id="insights-container">
                    <div className="insights-row">
                        <div className="insights-col insights-left-col">
                            <Insight
                                image={PilotingImage}
                                headerText="Piloting and Proof-of-Concept"
                                date="March 5, 2024"
                                text="It is essential to adopt a measured approach when rolling out AI-powered solutions. Given the novelty ..."
                                onClick={() => navigate("/learn/piloting-and-proof-of-concept")}
                            />
                        </div>
                        <div className="insights-col insights-right-col">
                            <Insight
                                image={AutomationImage}
                                headerText="Full Automation vs. Human-in-the-Loop"
                                date="March 9, 2024"
                                text="As businesses explore the potential of generative AI, one of the key decisions they face is whether to ..."
                                onClick={() => navigate("/learn/full-automation-vs-human-in-the-loop")}
                            />
                        </div>
                    </div>

                    <div className="insights-row">
                        <div className="insights-col insights-left-col">
                            <Insight
                                image={InHouseImage}
                                headerText="In-house vs. Outsourcing Custom AI Solutions"
                                date="March 9, 2024"
                                text="Once a company has decided to build a custom AI solution for a specific workflow, they have two main options ..."
                                onClick={() => navigate("/learn/in-house-vs-outsourcing-custom-ai-solutions")}
                            />
                        </div>
                        <div className="insights-col insights-right-col">
                            <Insight
                                image={TrainingImage}
                                headerText="Training vs. Fine-tuning vs. Using Existing Models"
                                date="March 9, 2024"
                                text="The advent of generative AI has brought about a paradigm shift in the way businesses approach AI implementation ..."
                                onClick={() => navigate("/learn/training-vs-fine-tuning-vs-using-existing-models")}
                            />
                        </div>
                    </div>
                </div>

            </div>

            <div className="homepage-container" id="meet-team-container">
                <div className="homepage-row">
                    <p className="home-page-header-text">
                        Meet the team
                    </p>
                </div>
                <div className="homepage-row" id="meet-team-sub-text-row">
                    <p id="meet-team-sub-text">
                        SP Labs is the consulting arm of Superpowered AI, an AI startup backed by Y Combinator. We’re a small, experienced team based in Salt Lake City, Utah. You’ll be working directly with our founding team.
                    </p>
                </div>
                <div className="homepage-row" id="meet-team-headshots-row">
                    <div className="meet-team-col-wrapper">
                        <div className="meet-team-col">
                            <img src={ZachHeadshot} className="headshot" onClick={() => window.open("https://www.linkedin.com/in/zach-mccormick-295a5953/", "_blank")} />
                            <p className="team-name-text">Zach McCormick</p>
                            <p className="team-title-text">Founder and co-CEO</p>
                        </div>
                        <div className="meet-team-col">
                            <img src={DillonHeadshot} className="headshot" onClick={() => window.open("https://www.linkedin.com/in/dillon-martin-8809b6126/", "_blank")} />
                            <p className="team-name-text">Dillon Martin</p>
                            <p className="team-title-text">Founder and co-CEO</p>
                        </div>
                    </div>
                    <div className="meet-team-col-wrapper">
                        <div className="meet-team-col">
                            <img src={NickHeadshot} className="headshot" onClick={() => window.open("https://www.linkedin.com/in/nick-mccormick-6813828b/", "_blank")} />
                            <p className="team-name-text">Nick McCormick</p>
                            <p className="team-title-text">Founder and Lead Developer</p>
                        </div>
                        <div className="meet-team-col">
                            <img src={JustinHeadshot} className="headshot" onClick={() => window.open("https://www.linkedin.com/in/justin-m-clark/", "_blank")} />
                            <p className="team-name-text">Justin Clark</p>
                            <p className="team-title-text">Founder and System Architect</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="homepage-container" id="get-started-container">
                <div className="homepage-row" id="get-started-row">
                    <p id="get-started-text">
                        Get started with a free 30 minute consultation
                    </p>
                </div>
                <ContactUsButton onClick={() => setShowContactModal(true)} />
            </div>

            <Footer />

        </section>
    )

}


function CarouselItem() {
    return (
        <Carousel interval={null}>
            <Carousel.Item>
                <div className="built-features-col">
                    <div className="built-feature-wrapper">
                        <div className="built-feature-container">
                            <p className="built-title-text">
                                API for retrieval augmented generation
                            </p>
                            <p className="built-sub-text">
                                This platform makes it easy for developers to build AI applications that require connecting the AI to external sources of knowledge. This platform achieves state of the art performance on a wide variety of tasks.
                            </p>
                        </div>
                    </div>
                </div>
            </Carousel.Item>
            <Carousel.Item>
                <div className="built-features-col">
                    <div className="built-feature-wrapper">
                        <div className="built-feature-container">
                            <p className="built-title-text">
                                GenMind - AI that cites its sources
                            </p>
                            <p className="built-sub-text">
                                GenMind is a horizontal AI platform for connecting AI to external sources of knowledge. All AI responses include citations so the user can verify accuracy. GenMind supports a wide variety of use cases, including long-form content generation and document reviews.
                            </p>
                        </div>
                    </div>
                </div>
            </Carousel.Item>
            <Carousel.Item>
                <div className="built-features-col">
                    <div className="built-feature-wrapper">
                        <div className="built-feature-container">
                            <p className="built-title-text">
                                AI marketing platform for financial advisors
                            </p>
                            <p className="built-sub-text">
                                We're helping a wealth tech startup build an AI-powered marketing platform for financial advisors. It helps advisors generate compelling and compliant marketing content, like blog posts and newsletters, with a single click. The platform leverages web search to automatically pull up-to-date information about financial markets.
                            </p>
                        </div>
                    </div>
                </div>
            </Carousel.Item>
        </Carousel>
    );
}


export const Insight = ({ image, headerText, date, text, onClick }) => {

    return (
        <div className="insight-container" onClick={onClick}>
            <div className="insight-image-col">
                <img src={image} className="insight-image" />
            </div>
            <div className="insight-content-col">
                <div className="insight-header-row">
                    <p className="insight-header-text">{headerText}</p>
                </div>
                <div className="insight-text-row">
                    <p className="insight-text">{text}</p>
                </div>
            </div>
        </div>
    )

}


export const ContactUsButton = ({ onClick }) => {
    return (
        <div className="contact-us-button-container" onClick={onClick}>
            <p className="contact-us-button-text">Contact Us</p>
        </div>
    )
}

/*
<div className="homepage-chat-thread-col">

                <SuperpoweredChatThread
                    apiKey={REACT_APP_API_KEY}
                    apiSecret={REACT_APP_API_SECRET}
                    threadId={null}
                    darkMode={false}
                    initialMessage={null}
                    chatConfig={{
                        knowledgeBaseIds: ["0ea1d193-f183-4d4a-9d42-f677151fece0"],
                        systemMessage: "",
                        responseLength: "medium",
                        model: "claude-3-opus",
                        temperature: 0.2,
                        useRSE: true
                    }}
                    customContainerStyle={{
                        height: "700px",
                        
                        borderRadius: "10px",
                        border: "2px solid #d1d1d1"
                    }}
                    introHeader="Try it yourself"
                    introDescription={""}
                    suggestedMessages={[]}
                    displaySources={"all"}
                    onMessageSendCallback={(payload, response, status) => handleResponse(payload, response, status)}
                />

            </div>
*/

export default Home;
